import { GlobalConfigBgClass } from '@ps/bridge/qc/base'
import qc from 'qc'

export interface IGlobalConfigBg {
  bgUrl: string
  bgColor:string
  bgHue:number
  bgSaturation:number
  bgLuminance:number
  bgBlur:number
  bgmSourceAudioDuration: number
  bgmSourceAudioUrl: string
  bgmAudioUrl: string
  bgmClipStartTime: number
  bgmClipEndTime: number
  bgmVolume: number
  bgmAutoPlay: boolean
  bgmLoopNumber: number
  bgmLoop: boolean
  bgmSize: number
  initBg:() => void
  initBgColor:()=>void
  updateBgFilter:(data:{hue: number;
    saturation: number;
    luminance: number;
    blur: number;})=>void
}

/**
 * @param node
 * @param addScriptIfScriptNotExist
 */
export const getScript = (node: qc.Node, addScriptIfScriptNotExist = true): IGlobalConfigBg | undefined => {
  const config: IGlobalConfigBg | undefined = node.getScript(GlobalConfigBgClass)
  if (config) {
    return config
  }
  if (addScriptIfScriptNotExist) {
    const config = node.addScript(GlobalConfigBgClass)
    return config
  }
  return config
}
